import { Button, styled } from '@ltvco/refresh-lib/theme';

export const PaginationButton = styled(Button)(() => ({
  textTransform: 'none',
  fontWeight: 500,
  borderRadius: '32px',
  transition: 'all 0.2s ease-in-out',
  padding: '8px 24px',
  minWidth: '120px',
}));

export const paginationButtonStyles = {
  textTransform: 'none',
  fontWeight: 500,
  borderRadius: '32px',
  transition: 'all 0.2s ease-in-out',
  padding: '8px 24px',
  minWidth: '120px',
} as const;
